import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AiFillCaretDown } from "react-icons/ai";
import classes from "./style.module.css";
import backimage from "../../../../assetsSRC/backsvg.svg";
import Dashboard from "./dashboard";
import Rendernow from "./rendernow";
import Support from "./support";
import Resources from "./resources";
import Downloads from "./downloads";
import Mail from "./mails";
import Homepage from "./homepage";
import Playfab from "./playfab";
import Tutorials from "./tutorials";

export const Admindashboard = () => {
  const [expands, setExpands] = useState({
    homepage: false,
    dashboard: false,
    render: false,
    support: false,
    resources: false,
    downloads: false,
    mail: false,
    playfab: false,
    tutorials: false,
  });

  // const admincomponent = useSelector((state) => state.reducer.AdminDashboard);

  const dispatch = useDispatch();

  const expandfun = (value) => {
    if (value === "home") {
      setExpands({ ...expands, homepage: true });
    } else if (value === "render") {
      setExpands({ ...expands, render: true });
    } else if (value === "support") {
      setExpands({ ...expands, support: true });
    } else if (value === "resources") {
      setExpands({ ...expands, resources: true });
    } else if (value === "downloads") {
      setExpands({ ...expands, downloads: true });
    } else if (value === "mail") {
      setExpands({ ...expands, mail: true });
    } else if (value === "playfab") {
      setExpands({ ...expands, playfab: true });
    } else if (value === "tutorials") {
      setExpands({ ...expands, tutorials: true });
    } else {
      setExpands({ ...expands, dashboard: true });
    }
  };
  const shrinkfun = (value) => {
    if (value === "home") {
      setExpands({ ...expands, homepage: false });
    } else if (value === "render") {
      setExpands({ ...expands, render: false });
    } else if (value === "support") {
      setExpands({ ...expands, support: false });
    } else if (value === "resources") {
      setExpands({ ...expands, resources: false });
    } else if (value === "downloads") {
      setExpands({ ...expands, downloads: false });
    } else if (value === "mail") {
      setExpands({ ...expands, mail: false });
    } else if (value === "playfab") {
      setExpands({ ...expands, playfab: false });
    } else if (value === "tutorials") {
      setExpands({ ...expands, tutorials: false });
    } else {
      setExpands({ ...expands, dashboard: false });
    }
  };

  useEffect(() => {
    dispatch({ type: "admindash" });
  }, []);

  return (
    <div
      className="container-fluid m-0 p-0 w-auto h-100 "
      style={
        {
          // backgroundImage: `url(${backimage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // width: "100%",
          // height: "100%",
        }
      }
    >
      <div className="row p-4">
        <div className="w-100 text-center">
          <div
            className={`${
              expands.homepage && classes.change
            } card shadow p-1 w-100 rounded bannerfont ${classes.pointers}`}
            onClick={() => {
              if (expands.homepage) {
                shrinkfun("home");
              } else {
                expandfun("home");
              }
            }}
          >
            Homepage
            <span>{expands.homepage && <AiFillCaretDown />}</span>
          </div>
          {expands.homepage && <Homepage />}
        </div>

        <div className="w-100 mt-1">
          <div
            className={`${
              expands.dashboard && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.dashboard) {
                shrinkfun("dash");
              } else {
                expandfun("dash");
              }
            }}
          >
            Dashboard
            <span>{expands.dashboard && <AiFillCaretDown />}</span>
          </div>
          {expands.dashboard && <Dashboard />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.render && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.render) {
                shrinkfun("render");
              } else {
                expandfun("render");
              }
            }}
          >
            RenderNow
            <span>{expands.render && <AiFillCaretDown />}</span>
          </div>
          {expands.render && <Rendernow />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.support && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.support) {
                shrinkfun("support");
              } else {
                expandfun("support");
              }
            }}
          >
            Support
            <span>{expands.support && <AiFillCaretDown />}</span>
          </div>
          {expands.support && <Support />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.resources && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.resources) {
                shrinkfun("resources");
              } else {
                expandfun("resources");
              }
            }}
          >
            Resources
            <span>{expands.resources && <AiFillCaretDown />}</span>
          </div>
          {expands.resources && <Resources />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.downloads && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.downloads) {
                shrinkfun("downloads");
              } else {
                expandfun("downloads");
              }
            }}
          >
            Downloads
            <span>{expands.downloads && <AiFillCaretDown />}</span>
          </div>
          {expands.downloads && <Downloads />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.mail && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.mail) {
                shrinkfun("mail");
              } else {
                expandfun("mail");
              }
            }}
          >
            Mailing List
            <span>{expands.mail && <AiFillCaretDown />}</span>
          </div>
          {expands.mail && <Mail />}
        </div>

        <div className="w-100 mt-1">
          <div
            className={`${
              expands.mail && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.playfab) {
                shrinkfun("playfab");
              } else {
                expandfun("playfab");
              }
            }}
          >
            Playfab Admins
            <span>{expands.playfab && <AiFillCaretDown />}</span>
          </div>
          {expands.playfab && <Playfab />}
        </div>
        <div className="w-100 mt-1">
          <div
            className={`${
              expands.tutorials && classes.change
            } card shadow-lg p-1 w-100 rounded bannerfont text-center ${
              classes.pointers
            }`}
            onClick={() => {
              if (expands.tutorials) {
                shrinkfun("tutorials");
              } else {
                expandfun("tutorials");
              }
            }}
          >
            Tutorials
            <span>{expands.tutorials && <AiFillCaretDown />}</span>
          </div>
          {expands.tutorials && <Tutorials />}
        </div>
      </div>
      <div className="row justify-content-center mt-2 bannertitle">
        Click for open & close
      </div>
    </div>
  );
};
